import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { settings } from "../data/settings";

const ScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        // Convertit la hauteur de la navbar (en rem ou px) en pixels
        const getNavbarHeightInPixels = () => {
            const heightStr = settings.navbar?.height || "5rem";
            if (heightStr.endsWith("rem")) {
            const remValue = parseFloat(heightStr);
            const baseFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize); // généralement 16px
            return remValue * baseFontSize;
            } else if (heightStr.endsWith("px")) {
            return parseFloat(heightStr);
            } else {
            return parseFloat(heightStr); // fallback
            }
        };
        setTimeout(() => {
            const navbarHeight = getNavbarHeightInPixels();
            const yOffset = -navbarHeight;
            const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

            window.scrollTo({ top: y, behavior: "smooth" });
            //el.scrollIntoView({ behavior: "smooth" });
        }, 100); // délai pour laisser le temps au DOM de se charger
      }
    }
  }, [location]);

  return null;
};

export default ScrollToHash;
